import axios from '@/libs/api.request'

const Api = {
  Desk: '/product/desk/detail',
  Plans: '/product/xr10/plans',
  Sales: '/product/xr10/sales'
}

export const getPlans = (type) => {
  return axios.request({
    url: Api.Plans + '?type=' + type,
    method: 'get'
  })
}

export const getSales = () => {
  return axios.request({
    url: Api.Sales,
    method: 'get'
  })
}

export const getDesk = () => {
  return axios.request({
    url: Api.Desk,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/product.js